var React = require('react');

function Fb (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Symbols","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd"},React.createElement("g",{"id":"fb"},[React.createElement("circle",{"id":"Oval","fill":"#FFFFFF","cx":"22.4","cy":"22.4","r":"22.4","key":0}),React.createElement("path",{"d":"M27.8,18.9158793 L23.847981,18.9158793 L23.847981,16.6542197 C23.847981,15.4872033 23.9421568,14.752164 25.600323,14.752164 L27.6946128,14.752164 L27.6946128,11.1561252 C26.6754964,11.0498272 25.6507743,10.997809 24.6249311,11 C21.5832779,11 19.3634204,12.8738557 19.3634204,16.3138399 L19.3634204,18.9158793 L16,18.9158793 L16,23.4391985 L19.3634204,23.4380676 L19.3634204,33.6166667 L23.847981,33.6166667 L23.847981,23.435806 L27.2853967,23.4346752 L27.8,18.9158793 Z","id":"Path","fill":"#7D7971","fillRule":"nonzero","key":1})])));
}

Fb.defaultProps = {"viewBox":"0 0 45 45","version":"1.1"};

module.exports = Fb;

Fb.default = Fb;
